import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAuth from "context/useAuth";
import { Link } from "react-router-dom";
import PagePreloader from "components/PagePreloader";

export default function LoginPage() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(false);

  const dismissError = () => setError("");
  const dismissSuccess = () => setSuccess("");

  useEffect(() => {
    if (user) navigate("/account");
  }, [user, navigate]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("sessionExpired") === "1") {
      setError("Your session expired. Please log in again.");
    }
  }, [location.search]);

  useEffect(() => {
    if (location.state?.registrationSuccess) {
      setSuccess(
        "Your account was created successfully. For your security, please log in to continue.",
      );
      navigate(`${location.pathname}${location.search}`, {
        replace: true,
        state: null,
      });
    }
  }, [location.pathname, location.search, location.state, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);
    try {
      await login(email, password);
      navigate("/account");
    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <PagePreloader time={100000} />}
      <div className="login_section pt-80 pb-80 p3-bg">
        <div className="container-fluid">
          <div className="row justify-content-between align-items-center">
            <div className="col-6 d-none d-lg-block">
              <img
                className="w-100"
                src="/assets/images/login.png"
                alt="Login Visual"
              />
            </div>
            <div className="col-lg-6 col-xl-5">
              <div className="px-4 pt-4 pb-5">
                {error && (
                  <div
                    role="alert"
                    className="d-flex align-items-start justify-content-between gap-3 mb-4 px-4 py-3"
                    style={{
                      backgroundColor: "rgba(255, 0, 0, 0.2)",
                      borderRadius: "50px",
                    }}
                  >
                    <span className="pe-2">{error}</span>
                    <button
                      type="button"
                      onClick={dismissError}
                      aria-label="Dismiss login error"
                      className="btn p-0 border-0 bg-transparent text-white lh-1"
                      style={{ fontSize: "1.1rem" }}
                    >
                      ×
                    </button>
                  </div>
                )}
                {success && (
                  <div
                    role="status"
                    className="d-flex align-items-start justify-content-between gap-3 mb-4 px-4 py-3"
                    style={{
                      backgroundColor: "rgba(0, 255, 0, 0.2)",
                      borderRadius: "50px",
                    }}
                  >
                    <span className="pe-2">{success}</span>
                    <button
                      type="button"
                      onClick={dismissSuccess}
                      aria-label="Dismiss registration success"
                      className="btn p-0 border-0 bg-transparent text-white lh-1"
                      style={{ fontSize: "1.1rem" }}
                    >
                      ×
                    </button>
                  </div>
                )}
                <h3 className="mb-6">Login</h3>
                <p className="mb-4">
                  Log in to continue your trading adventure.
                </p>
                <form onSubmit={handleSubmit} className="login_section__form">
                  <input
                    className="n11-bg mb-3"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <input
                    className="n11-bg mb-3"
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <button className="cmn-btn w-100" type="submit">
                    Log In
                  </button>
                </form>
                <span className="d-block mt-3 text-center">
                  No account?{" "}
                  <Link
                    to="/register"
                    className="login-signup-link"
                    style={{
                      color: "rgb(var(--g1))",
                      textDecoration: "underline",
                      textUnderlineOffset: "3px",
                      fontWeight: 600,
                      display: "inline-block",
                    }}
                  >
                    Sign up
                  </Link>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
